import { render, staticRenderFns } from "./LandingSRsList.vue?vue&type=template&id=4e88aec6&scoped=true&"
import script from "./LandingSRsList.vue?vue&type=script&lang=js&"
export * from "./LandingSRsList.vue?vue&type=script&lang=js&"
import style0 from "./LandingSRsList.vue?vue&type=style&index=0&id=4e88aec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88aec6",
  null
  
)

export default component.exports